import { render, staticRenderFns } from "./BranchProductAnalysis.vue?vue&type=template&id=8008c6a8&scoped=true"
import script from "./BranchProductAnalysis.vue?vue&type=script&lang=js"
export * from "./BranchProductAnalysis.vue?vue&type=script&lang=js"
import style0 from "./BranchProductAnalysis.vue?vue&type=style&index=0&id=8008c6a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8008c6a8",
  null
  
)

export default component.exports